import Crud from '../views/MoviasEventRule/Crud'
import Entity from '../views/MoviasEventRule/Add'

const breadcrumb = text => [
    {
        text: 'List',
        active: false,
        to: '/moviasEventRules',
    },
    {
        text,
        active: true,
    },
]

const routes = {
    path: '/moviasEventRules',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/moviasEventRules/add',
            name: 'NewMoviasEventRules',
            component: Entity,
            meta: {
                ability: 'eventos_movias.gerenciar',
                pageTitle: 'Configurações de eventos',
                breadcrumb: breadcrumb('Add'),
            },
        },
        {
            path: '/moviasEventRules/edit/:id?',
            name: 'EditMoviasEventRules',
            component: Entity,
            meta: {
                ability: 'eventos_movias.gerenciar',
                pageTitle: 'Configurações de eventos',
                breadcrumb: breadcrumb('Edit'),
            },
        },
        {
            path: '/moviasEventRules',
            name: 'list-moviasEventRules',
            component: Crud,
            meta: {
                ability: 'eventos_movias.ver',
                pageTitle: 'Configurações de eventos',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
